<template>
  <div class="trigger trigger-border">
    <label>{{ $t('gatilhos-de-aderencia') }}</label>
    <span class="flex-row justify-around">

      
      <div v-if="!isRta" class="trigger-border">
        <span :title="triggerInfo.ALT.title" class="element-overlap">
          <b-form-checkbox id="checkbox-5" v-model="altActive" @change="sendALT" class="trigger-checkBox"
            name="checkbox-5" value="true">
            {{ $t('aderencia-turno-minima') }} 
          </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ALT.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-fca-4'), }" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
        </span>
        <span class="img-width100 trigger-box">
        </span>
      </div>

      <div class="trigger-border">
        <span :title="triggerInfo.ALD.title" class="element-overlap">
          <b-form-checkbox id="checkbox-6" v-model="aldActive" @change="sendALD" class="trigger-checkBox"
            name="checkbox-6" value="true">
            {{ $t('aderencia-diaria-minima') }} 
          </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ALD.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-fca-5'), }" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
        </span>
        <span class="trigger-box img-width100">
        </span>
      </div>

      <div v-if="!isRta" class="trigger-border">
        <span :title="triggerInfo.ATS.title" class="element-overlap">
          <b-form-checkbox id="checkbox-7" v-model="atsActive" @change="sendATS" class="trigger-checkBox"
            name="checkbox-7" value="true">
            {{ $t('turnos-sem-atingir-meta-de-aderencia') }} 
          </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ATS.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-fca-6'), }" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
        </span>
        <div class="flex-row justify-around trigger-box">
          <label for="minute-interval">{{ $t('nao-conformidades') }} </label>
          <b-form-input type="number" size="sm" v-model="atsUnconformities" @keyup="sendATS" @change="sendATS" id="minute-interval" placeholder="1" 
            @input="handleInput('atsUnconformities', $event)" min="1">
          </b-form-input>
        </div>
      </div>
    </span>
    <span class="flex-row mt-4 justify-around">
      <div class="trigger-border">
        <span :title="triggerInfo.ADI.title" class="element-overlap">
          <b-form-checkbox id="checkbox-8" v-model="adiActive" @change="sendADI" class="trigger-checkBox"
            name="checkbox-8" value="true">
            {{ $t('dias-sem-atingir-meta') }} </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ADI.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-fca-7'), }" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
        </span>
        <div class="flex-row justify-around trigger-box width300">
          <label for="minute-interval">{{ $t('nao-conformidades') }} </label>
          <b-form-input type="number" size="sm" v-model="adiUnconformities" @keyup="sendADI" @change="sendADI" id="minute-interval" placeholder="1"
            @input="handleInput('adiUnconformities',$event)" min="1">
          </b-form-input>
        </div>
      </div>
      <div v-if="!isRta" class="trigger-border">
        <span :title="triggerInfo.ATM.title" class="element-overlap">
          <b-form-checkbox id="checkbox-9" v-model="atmActive" @change="sendATM" class="trigger-checkBox"
            name="checkbox-9" value="true">
            {{ $t('dias-sem-atingir-meta-de-aderencia-do-turno') }} </b-form-checkbox>
          <b-icon v-if="!show" @click="() => showInfo(triggerInfo.ATM.description)" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
          <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-fca-8'), }" class="question-icon" icon="question-circle-fill"
            aria-hidden="true">
          </b-icon>
        </span>
        <div class="flex-row justify-around trigger-box">
          <label for="minute-interval">{{ $t('nao-conformidades') }} </label>
          <b-form-input type="number" size="sm" v-model="atmUnconformities" @keyup="sendATM" @change="sendATM" id="minute-interval" placeholder="1"
            @input="handleInput('atmUnconformities', $event)" min="1">
          </b-form-input>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import MediatorTrigger from "../tools/MediatorTrigger"

export default {
  name: "TriggerReliability",
  props: ["triggerInfo", "reset", "triggerSelected", "show", "isRta"],
  inject: ["showInfo", "showResponsibles"],

  data() {
    return {
      altActive: false,
      aldActive: false,
      atsActive: false,
      atsUnconformities: 1,

      adiActive: false,
      adiUnconformities: 1,

      atmActive: false,
      atmUnconformities: 1,
    }
  },

  watch: {
    reset() {
      this.resetForm();
    },
  },

  methods: {
    loadForm(value) {
      if (!value.ALT) return
      this.loadData(value)
    },

    sendALT() {
      MediatorTrigger.notify({
        active: this.altActive,
      }, "setALT")
    },

    sendALD() {
      MediatorTrigger.notify({
        active: this.aldActive,
      }, "setALD")
    },

    sendATS() {
      MediatorTrigger.notify({
        active: this.atsActive,
        unconformities: this.atsUnconformities
      }, "setATS")
    },

    sendADI() {
      MediatorTrigger.notify({
        active: this.adiActive,
        unconformities: this.adiUnconformities
      }, "setADI")
    },

    sendATM() {
      MediatorTrigger.notify({
        active: this.atmActive,
        unconformities: this.atmUnconformities
      }, "setATM")
    },

    loadData(value) {
      this.resetForm()
      this.altActive = value.ALT.active;
      this.aldActive = value.ALD.active;

      this.atsActive = value.ATS.active;
      if (value.ATS.configurationJSON) {
        let configurationJSON = JSON.parse(value.ATS.configurationJSON)
        this.atsUnconformities = configurationJSON.unconformities;
      }

      this.adiActive = value.ADI.active;
      if (value.ADI.configurationJSON) {
        let configurationJSON = JSON.parse(value.ADI.configurationJSON)
        this.adiUnconformities = configurationJSON.unconformities;
      }

      this.atmActive = value.ATM.active;
      if (value.ATM.configurationJSON) {
        let configurationJSON = JSON.parse(value.ATM.configurationJSON)
        this.atmUnconformities = configurationJSON.unconformities;
      }
    },

    openResponsible(triggercode) {
      this.showResponsible(triggercode)
    },

    resetForm() {
      this.altActive = false;
      this.aldActive = false;
      this.atsActive = false;
      this.atsUnconformities = 1;
      this.adiActive = false;
      this.adiUnconformities = 1;
      this.atmActive = false;
      this.atmUnconformities = 1;
    },

    handleInput(prop, event) {
      let cleanedValue = event.replace(/\D/g, '');
      if (prop == 'atsUnconformities')
        this.atsUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else if (prop == 'adiUnconformities')
        this.adiUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else
        this.atmUnconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
    }
  },

  mounted() {
    console.log("TriggerReliability - isRta:", this.isRta);
    MediatorTrigger.notify(this, "initTriggerReliability");
  }
}
</script>

<style scoped src="../style.css"></style>
